import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Box, Button, EmptyState, Lottie } from '@node-space/ui-components'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { PathNames } from 'constants/General'
import { ActionIds } from 'types/types'
import { RewardCompoundedCalculator } from './RewardCompoundedCalculator'

export const RewardsNoWallets = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleAddWallet = () => {
    navigate(`${PathNames.WALLETS}?action=${ActionIds.WALLET_CREATE}`)
  }
  return (
    <Box flexCol gap={16} className="lg:grid xl:grid-cols-[1fr_1fr]">
      <EmptyState
        testId="rewards-assets-no-wallets-empty-state"
        LottiePlayer={<Lottie src="welcome" />}
        title={t('rewards.noWalletsState.title')}
        description={
          <>
            {t('rewards.noWalletsState.description')}
            <ExternalLink href="https://docs.bvnk.com/docs/introduction" target="_blank">
              {t('rewards.descriptionLink')}
            </ExternalLink>
          </>
        }
        PrimaryButton={
          <Button onClick={handleAddWallet}>{t('rewards.noWalletsState.addWallet')}</Button>
        }
      />

      <RewardCompoundedCalculator />
    </Box>
  )
}
